import { render, staticRenderFns } from "./DialogSetRoomFee.vue?vue&type=template&id=2eccfdc6&"
import script from "./DialogSetRoomFee.vue?vue&type=script&lang=js&"
export * from "./DialogSetRoomFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports